export * from './search-result/gallery.search.result.component';
export * from './user-gallery/user.gallery.component';



// WEBPACK FOOTER //
// ./src/components/gallery/index.ts